import React, {useEffect, useState} from 'react';
import { Alert, Container } from 'react-bootstrap';
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';

import CustomNavbar from '../../../components/CustomNavbar';
import SidebarDashboard from '../../../components/SidebarDashboard';
import { getSurveyTemplates, deleteSurveyTemplate, resetSurveyTemplate } from '../../../redux/survey/surver_template/actions';
import CustomTable from '../../../components/CustomTable';
import HeaderWithSearchForm from '../../../components/header_with_search_form/HeaderWithSearchForm';
import CustomPagint from '../../../components/CustomPagint';
import { customTableColumns } from './CustomTableColumns';

const SurveyTemplate = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("");
  const dispatch = useDispatch();
  const { surveyTemplates, surveyTemplatesLength, isLoading, error } = useSelector(state => state.surveyTemplate);
  
  const fetchSurveyTemplates = (offs=offset, limi=limit, filt=filter) => dispatch(getSurveyTemplates({offset:offs, limit:limi, filter:filt}));

  const pages = Math.ceil(surveyTemplatesLength / limit);
  const history = useHistory();

  useEffect(() => {
    fetchSurveyTemplates();
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    const offs = 0;
    setFilter(e.target.search.value);
    setCurrentPage(1);
    setOffset(offs);
    fetchSurveyTemplates(offs, limit, e.target.search.value);
  }

  const onShowSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const onEdit = (id) => {
    history.push(`/encuestas/${id}/update`);
  }

  const onAdd = () => {
    dispatch(resetSurveyTemplate());
    history.push("/encuestas/crear");
  }

  const onStartSurvey = (id) => {
    history.push(`/encuestas/${id}/formulario?debugMode=true`);
  }

  const onShowResults = (id) => {
    history.push(`/encuestas/${id}/resultados`);
  }

  const onDelete = (id) => {
    if(window.confirm("¿Estás seguro de eliminar esta encuesta?")){
      dispatch(deleteSurveyTemplate(id));
    }
  }

  const columns = customTableColumns(onEdit, onDelete, onShowResults, onStartSurvey);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={showSidebar} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <HeaderWithSearchForm 
            onSearch={onSearch} 
            title="Encuestas"
            showNewRecordButton={true}
            onAdd={onAdd} />
          <hr />
        {
          !isLoading && error && <Alert variant="danger">{error}</Alert>
        }
        <CustomTable 
          columns={columns}
          data={surveyTemplates}
          isLoadingData={isLoading}
          isErrorToLoadData={!!error}
          maySortableRows={false} />
        <CustomPagint
          limit={limit}
          setLimit={setLimit}
          offset={offset}
          setOffset={setOffset}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          dataLenght={surveyTemplatesLength}
          pages={pages}
          pagFunc={fetchSurveyTemplates} />
        </Container>
      </div>
    </>
  )
}

export default SurveyTemplate